import { SyntheticEvent, useState } from "react";
import { Card, Tab, Tabs } from "@mui/material";

import ModelosPesquisa from "./ModelosPesquisa";
import RelatorioRespostasPesquisa from "./RelatorioRespostasPesquisa";
import RelatorioTotalizadoresPesquisa from "./RelatorioTotalizadoresPesquisa";
import styles from "../Shared/AdminWorkspace.module.css";

type PesquisaTab = "modelos" | "respostas" | "totalizadores";

const PesquisasSatisfacao = () => {
  const [activeTab, setActiveTab] = useState<PesquisaTab>("modelos");

  return (
    <div className={styles.container}>
      <Card className={styles.tabsCard}>
        <div className={styles.tabsWrap}>
          <Tabs
            value={activeTab}
            onChange={(_: SyntheticEvent, value: PesquisaTab) => setActiveTab(value)}
          >
            <Tab value="modelos" label="Modelos" />
            <Tab value="respostas" label="Respostas da Pesquisa" />
            <Tab value="totalizadores" label="Totalizadores da Pesquisa" />
          </Tabs>
        </div>

        <div className={styles.content}>
          {activeTab === "modelos" && <ModelosPesquisa />}
          {activeTab === "respostas" && <RelatorioRespostasPesquisa />}
          {activeTab === "totalizadores" && <RelatorioTotalizadoresPesquisa />}
        </div>
      </Card>
    </div>
  );
};

export default PesquisasSatisfacao;
